import { Component, OnInit, Input } from '@angular/core';

import { AuthService } from '@app/auth/services/auth.service';
import { SideMenuDosService } from '@app/services/side-menu-dos.service';
import { User } from '@app/models/user-data';
import { Routes } from '@app/constants/routes.constants';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  @Input() user: User;
  @Input() emailFromToken: string;
  private readonly _currentYear = new Date().getFullYear();
  private readonly _currentMonth = new Date().getMonth();
  readonly homeLink = this._authService.isAdmin
    ? Routes.Timesheets
    : `${Routes.Timesheet}/${this._currentYear}/${this._currentMonth}`;

  constructor(private _authService: AuthService, private _sideMenuDosService: SideMenuDosService) {}

  ngOnInit(): void {}

  onSignOut(): void {
    this._authService.signOut();
  }

  toggleSideMenu(): void {
    this._sideMenuDosService.toggle();
  }
}
